import Hooks from "@hooks";
import React from "react";
import { Table } from "../../../../../components";
import { System } from "../../../../../context";
import { Option } from "./option";

type Props = {
  filters: {
    search: string;
    host: string[];
    type: string[];
  };
  onSelect: (application: System["application"]) => void;
};

export const Options: React.FC<Props> = ({ filters, onSelect }) => {
  const applications = Hooks.useApplications();
  const options = React.useMemo(() => {
    //console.log(applications);
    return applications.value
      ? applications.value.filter(({ host, name, type, metadata }) => {
          const { search } = filters;

          if (
            search &&
            (!name.match(
              new RegExp(search.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "i")) && (!metadata?.match(
                new RegExp(search.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "i")
              )))
          ) {
            return false;
          }
         
          if (filters.host.length && !filters.host.includes(host)) {
            return false;
          }
          if (filters.type.length && !filters.type.includes(type)) {
            return false;
          }

          return true;
        })
      : [];
  }, [applications.value, filters]);

  return (
    <Table
      columns={[
        { label: "Application / Device Type / Domain Account" },
        { label: "Domain / Host", width: "160px" },
        { label: "Select", width: "100px" },
      ]}
      rowHeight={43}
      virtualized
      loading={applications.fetching}
    >
      {options.map((application) => (
        <Option
          key={application.id}
          application={application}
          onSelect={onSelect}
        />
      ))}
    </Table>
  );
};
